import React, { ChangeEvent, FocusEvent, KeyboardEvent, useCallback, useState, useRef, useEffect } from "react";
import { Tooltip } from "react-tooltip";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios, { AxiosError } from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./c360datepicker.css";
import { CusaC360b2bInterface } from "../../interface/redux-state/CusaC360b2bInterface";
import {
  resetStateAndError,
  setCvv,
  setCardType,
  setExpYearMonth,
  setExpYearMonthValid,
  setAvsName,
  setBillingAddress,
  setDecryptParams,
  setAmount,
  setMicroformLoaded,
  setValidationMessage,
  setFormDisabled,
  setProxyUrl,
  setDatePickerOpen,
  setLogErrorReference,
  setInitializationComplted,
  setCybrError,
  setProcessForm,
} from "../../redux-store/reducer/cusac360b2bSlice";
import { setAppName } from "../../utils/consoleLog";

import { tceppsActions } from "../../redux-store/reducer/tcepps_slice";
import { tokenCreatedAction, microformInitializedAction, unmountAction, contextLoadedAction } from "../../redux-store/reducer/paymentSlice";
import { LogService, LOGERRORLEVEL, LOGINFOLEVEL } from "../../service/logService";
import PaymentService from "../../service/paymentService";
import { getYearsFromToday, isCybersourceTimedout, getTimedoutDummyToken } from "../../utils/calendarUtil";

import classesC360b2bcarepak from "./CusaC360B2bCarepak.module.css";
import { extractClientLibrary, extractDomain, parseToken, getDecryptParams, getStringify } from "../../utils/utils";
import { componentVarObject, ComponentVarProps } from "../../utils/ComponentConstant";
import { isDateNumber, isNumber } from "../../utils/calendarUtil";
import CpgmuiService from "../../service/CpgmuiService";
// import range from "lodash/range";

const Buffer = require("buffer/").Buffer; // note: the trailing slash is important!

let creditCardMicroNumber: any;
let cvvMicroSecurityCode: any;
const customerNameMaxLength = 90;

const margin20Style = {
  margin: "20px 0",
} as React.CSSProperties;
const creditCardStyle = {
  fontSize: "14px",
  fontFamily: "Proxima Nova",
  paddingLeft: "0em",
  // marginRight: "20px",
  height: "32px",
  color: "fieldtext",
  letterSpacing: "normal",
  wordSpacing: "normal",
  lineHeight: "normal",
  textIndent: "0px",
  textShadow: "none",
  display: "inline-block",
  cursor: "text",
  backgroundColor: "#ffffff",
  width: "100%",
  margin: "0em .5em 0em .5em",
  borderWidth: "1px",
  // borderStyle: "solid",
  borderTopStyle: "solid",
  borderBottomStyle: "solid",
  borderLeftStyle: "none",
  borderRightStyle: "none",
  borderColor: "grey",
  border: "1px solid none rgba(128, 128, 128, 0.9)",
  // borderColor: "-internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133))",
  // borderImage: "initial",
} as React.CSSProperties;
const flexStyles = {
  input: {
    cursor: "text",
    color: "#171719",
  },
  "::placeholder": { color: "#747474" },
  ":focus": { color: "black", borderColor: "#4d80e6 !important", border: "1px solid none rgba(77, 128, 230, 1)" },
  ":disabled": { cursor: "not-allowed" },
  valid: { color: "#171719" },
  invalid: { color: "#a94442" },
  // ":hover": {
  //   "font-style": "italic",
  // },
} as React.CSSProperties;

const tooltipStyle = {
  fontSize: "10pt",
  backgroundColor: "#337ab7",
  padding: "2px 1px 6px 1px",
} as React.CSSProperties;

const toDay = new Date();
const currentMonthYear = toDay.toLocaleString("en-US", { year: "numeric" }) + toDay.toLocaleString("en-US", { month: "2-digit" });
// const currentYear = toDay.getFullYear();
// const sixYearFromNow = new Date();
// sixYearFromNow.setFullYear(sixYearFromNow.getFullYear() + 7);
//  renderCustomHeader={({ date, changeYear }) => (
//                               <select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(+value)}>
//                                 {range(currentYear, sixYearFromNow.getFullYear()).map((year: number) => (
//                                   <option key={year} value={year}>
//                                     {year}
//                                   </option>
//                                 ))}
//                               </select>
//                             )}

const EMPTYCUSTOMERNAMEMESSAGE = "Please enter Card Holder Name.";
const FORMINITIZING = "Browser initializing. Please wait and retry.";
const INVALIDAXIOSMESSAGE = "AxiosError. ";
const INVALIDCARDMESSAGE = "Please enter a valid credit card number.";
const INVALIDCVVMESSAGE = "Please enter a valid CVV Number.";
const INVALIDDATEMESSAGE = "This card has expired. Please use a card with a valid expiration date.";
const PROCESSING = "Processing....  ";
const FIELDISREQUIRED = "The Field is Required.";

export function CusaC360B2bCarepakComponent(this: any) {
  const dispatch = useDispatch();
  const carepakState = useSelector((state: any) => state.cusac360b2b) as CusaC360b2bInterface;
  const tceppsState = useSelector((state: any) => state.tcepps);
  const paymentInfo = useSelector((state: any) => state.paymentInfo);

  const customerNameRef = useRef<HTMLInputElement>(null);
  const datePickerRef = useRef<any>(null);
  const dateKeyCode = useRef<string>("-1");
  const dateSelectionStart = useRef<number>(0);
  const dateSelectionEnd = useRef<number>(0);

  const componentObjRef = useRef<ComponentVarProps>(componentVarObject);

  const [creditCardNumberBorderClass, setCreditCardNumberBorderClass] = useState("");
  const [securityCodeBorderClass, setSecurityCodeBorderClass] = useState("");
  const [datePickerBorderClass, setDatePickerBorderClass] = useState("");
  const [isLargeScreen, setLargeScreen] = useState(false);
  const [windowSize] = useState({
    width: window.innerWidth,
  });

  const { appKey } = useParams();

  function setCreditCardType(newValue: string) {
    switch (newValue) {
      case "VI":
      case "visa":
        componentObjRef.current.glblCreditCardType = "VI";
        break;
      case "MC":
      case "mastercard":
        componentObjRef.current.glblCreditCardType = "MC";
        break;
      case "AX":
      case "amex":
        componentObjRef.current.glblCreditCardType = "AX";
        break;
      case "DI":
      case "discover":
        componentObjRef.current.glblCreditCardType = "DI";
        break;
      default:
        componentObjRef.current.glblCreditCardType = "";
        break;
    }
  }

  const convertMMYYYYToDate = (mmYYYYString: string) => {
    const [month, year] = mmYYYYString.split("/");
    return new Date(+year, +month - 1); // Month is 0-indexed
  };

  const addYears = (years: number) => {
    const newDate = new Date(); // Create a new Date instance to avoid mutating the original date
    newDate.setMonth(11);
    newDate.setFullYear(newDate.getFullYear() + years);
    return newDate;
  };

  const isOlderDate = (date1: Date) => {
    const d1 = new Date(date1);
    const d2 = new Date(toDay);
    d2.setDate(1);

    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);

    if (d1 < d2) {
      return true; // date1 is before toDay
    } else if (d1 > d2) {
      return false; // date1 is after toDay
    } else {
      return false; // date1 and toDay are the same
    }
  };

  const handleDateChange = (date: Date | null) => {
    if (date) {
      dispatch(setExpYearMonth({ ccExpYearMonth: date }));
      if (!isNaN(date.getTime())) {
        // console.log("1 setExpYearMonthValid ccExpExpired: " + (date < toDay) + " ccExpInvalid: false ccExpInvalid: false");
        dispatch(setExpYearMonthValid({ ccExpExpired: isOlderDate(date), ccExpInvalid: false, ccExpMissing: false }));
      } else {
        // console.log("2 setExpYearMonthValid ccExpExpired: true ccExpInvalid: true  ccExpInvalid: false");
        dispatch(setExpYearMonthValid({ ccExpExpired: true, ccExpInvalid: true, ccExpMissing: false }));
      }
    } else {
      // console.log("3 setExpYearMonthValid ccExpExpired: true ccExpInvalid: true  ccExpInvalid: true");
      // dispatch(setExpYearMonthValid({ ccExpExpired: true, ccExpInvalid: true, ccExpMissing: true }));
    }
  };

  const handleDateSelect = (date: Date | null) => {
    if (date) {
      dispatch(setExpYearMonth({ ccExpYearMonth: date }));
      // console.log("4 setExpYearMonthValid ccExpExpired: " + (date < toDay) + " ccExpInvalid: false  ccExpInvalid: false");
      dispatch(setExpYearMonthValid({ ccExpExpired: isOlderDate(date), ccExpInvalid: false, ccExpMissing: false }));
    } else {
      // setExpirationMonthYearDate(toDay);
    }
  };

  // const keyCodeArray = [191, 8, 86, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
  const keyCodeArray = ["/", "Backspace", "V", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  const handleChangeRaw = (date: any) => {
    if (date && date.target) {
      let newValue = date.target.value;
      // if not composing
      if (dateKeyCode.current !== "-1" && newValue) {
        if (dateKeyCode.current && keyCodeArray.includes(dateKeyCode.current)) {
          if (dateKeyCode.current !== "/") {
            /* != / Slash */
            //- != Backspace
            if (dateKeyCode.current !== "Backspace") {
              if (newValue.length === 1 && newValue >= "2" && isNumber(newValue)) {
                newValue = "0" + newValue + "/";
              } else if (newValue.length === 2 && newValue >= "01" && newValue <= "12") {
                newValue = newValue + "/";
              } else if (
                newValue.length === 2 &&
                dateSelectionStart.current >= 2 &&
                dateSelectionStart.current === dateSelectionEnd.current &&
                isDateNumber(newValue)
              ) {
                newValue = newValue + "/";
              } else if (dateKeyCode.current === "V" && newValue.length === 6) {
                //- === KeyV
                //- to handle copy & paste of 8 digit
                newValue = newValue.substring(0, 2) + "/" + newValue.substring(2, 4);
              }
              //- == Backspace
            } else {
              //- backspace would skip the slashes and just remove the numbers
              if (newValue.length === 3 && !(dateSelectionStart.current <= 1)) {
                newValue = newValue.substring(0, 2);
              }
            }
          } else {
            //- == /
            //remove slashes to avoid 12//01/2014
            if (newValue.length !== 3) {
              newValue = newValue.substring(0, newValue.length - 1);
              // } else if (isDateNumber(newValue)) {
              // newValue = newValue + "20";
            }
          }
          date.target.value = newValue;
          if (newValue && newValue.length === 5) {
            const newRaw = new Date(2000 + +newValue.substring(3), +newValue.substring(0, 2) - 1, 1);
            if (!isNaN(newRaw.getTime())) {
              dispatch(setExpYearMonth({ ccExpYearMonth: newRaw }));
              // console.log("5 setExpYearMonthValid ccExpExpired: " + (newRaw < toDay) + " ccExpInvalid: false  ccExpInvalid: false");
              dispatch(setExpYearMonthValid({ ccExpExpired: isOlderDate(newRaw), ccExpInvalid: false, ccExpMissing: false }));
            } else {
              // console.log(
              //   "6 setExpYearMonthValid ccExpExpired: " + carepakState.error.ccExpExpired + " ccExpInvalid: true  ccExpInvalid: false"
              // );
              // dispatch(setExpYearMonthValid({ ccExpExpired: carepakState.error.ccExpExpired, ccExpInvalid: true, ccExpMissing: false }));
            }
          } else {
            // console.log(
            //   "7 setExpYearMonthValid ccExpExpired: " + carepakState.error.ccExpExpired + " ccExpInvalid: true  ccExpInvalid: true"
            // );
            // dispatch(setExpYearMonthValid({ ccExpExpired: carepakState.error.ccExpExpired, ccExpInvalid: true, ccExpMissing: true }));
          }
        }
      }
    } else {
      // dispatch(setExpYearMonthValid({ ccExpExpired: carepakState.error.ccExpExpired, ccExpInvalid: true, ccExpMissing: true }));
    }
  };

  const onBlurHandler = (identifier: string, event: FocusEvent & { target: HTMLElement | HTMLInputElement }) => {
    switch (identifier) {
      case "expirationMonthYear":
        dispatch(setDatePickerOpen({ isDatePickerOpen: false }));
        break;
      case "customerName":
        const target = event.target as HTMLInputElement;
        dispatch(
          setAvsName({
            avsName: target.value.toUpperCase(),
            avsNameEmpty: target.value && target.value.trim().length > 0 ? false : true,
          }),
        );
        break;
    }
  };

  const onKeyDownHandler = (identifier: string, event: KeyboardEvent<HTMLElement | HTMLInputElement>) => {
    if (identifier === "customerName") {
      if (event.key === "Tab") {
        if (!event.shiftKey) {
          if (creditCardMicroNumber !== undefined && creditCardMicroNumber !== null) {
            creditCardMicroNumber.focus();
          }
        } else {
          if (cvvMicroSecurityCode !== undefined && cvvMicroSecurityCode !== null) {
            cvvMicroSecurityCode.focus();
          }
        }
      }
    } else {
      dateKeyCode.current = event.key ? event.key : "-1";
      try {
        // @ts-ignore
        dateSelectionStart.current = event.target.selectionStart;
      } catch (error) {}
      try {
        // @ts-ignore
        dateSelectionEnd.current = event.target.selectionEnd;
      } catch (error) {}

      if (event.key === "Tab") {
        if (identifier === "expirationMonthYear" && event.shiftKey) {
          if (creditCardMicroNumber !== undefined && creditCardMicroNumber !== null) {
            creditCardMicroNumber.focus();
          }
        } else if (identifier === "expirationMonthYear" && !event.shiftKey) {
          if (cvvMicroSecurityCode !== undefined && cvvMicroSecurityCode !== null) {
            cvvMicroSecurityCode.focus();
          }
        }
      }
    }
  };

  const checkCreditCard = useCallback(() => {
    let errorMessage = "";

    if (carepakState.decryptParams && Object.keys(carepakState.decryptParams).length > 0 && carepakState.microformLoaded) {
      let setFocusSet = false;
      let userMonthYear = datePickerRef.current?.input.value.toLocaleString();

      if (componentObjRef.current.cardMessage !== "" || carepakState.error.cardInvalid || carepakState.error.cardMissing) {
        errorMessage = (errorMessage.length > 0 ? " " : "") + INVALIDCARDMESSAGE;
        if (creditCardMicroNumber !== undefined && creditCardMicroNumber !== null) {
          creditCardMicroNumber.focus();
        }
        setFocusSet = true;
      }
      if (componentObjRef.current.cvvMessage !== "" || carepakState.error.cvvInvalid || carepakState.error.cvvEmpty) {
        errorMessage += (errorMessage.length > 0 ? " " : "") + INVALIDCVVMESSAGE;
        if (!setFocusSet) {
          if (cvvMicroSecurityCode !== undefined && cvvMicroSecurityCode !== null) {
            cvvMicroSecurityCode.focus();
          }
        }
        setFocusSet = true;
      }
      if (!userMonthYear || userMonthYear.trim().length !== 5 || !isNumber(userMonthYear)) {
        userMonthYear = "";
      } else {
        userMonthYear = "20" + userMonthYear.substring(3) + userMonthYear.substring(0, 2);
      }
      if (userMonthYear < currentMonthYear) {
        errorMessage += (errorMessage.length > 0 ? " " : "") + INVALIDDATEMESSAGE;
        // console.log("8 setExpYearMonthValid ccExpExpired: true  ccExpInvalid: false  ccExpInvalid: " + (userMonthYear === ""));
        dispatch(setExpYearMonthValid({ ccExpExpired: true, ccExpInvalid: false, ccExpMissing: userMonthYear === "" }));
        if (!setFocusSet) datePickerRef.current?.input.focus();
        setFocusSet = true;
      }
      if (componentObjRef.current.otherErrMsg !== "") {
        errorMessage += componentObjRef.current.otherErrMsg;
        if (!setFocusSet) {
          if (creditCardMicroNumber !== undefined && creditCardMicroNumber !== null) {
            creditCardMicroNumber.focus();
          }
        }
        // setFocusSet = true;
      }
      if (customerNameRef.current?.value === "") {
        errorMessage += (errorMessage.length > 0 ? " " : "") + EMPTYCUSTOMERNAMEMESSAGE;
        dispatch(
          setAvsName({
            avsName: customerNameRef.current?.value.trim().toUpperCase(),
            avsNameEmpty: true,
          }),
        );

        customerNameRef.current?.focus();
      }
    } else {
      errorMessage = FORMINITIZING;
    }

    if (errorMessage === "") {
      dispatch(setValidationMessage({ validationMessage: "" }));
      componentObjRef.current.isBackgroundRed = false;
      return true;
    } else {
      componentObjRef.current.isBackgroundRed = true;
      dispatch(setValidationMessage({ validationMessage: "" }));
      const messageObj = {
        eventSource: "cpgmui",
        eventType: "Form Validation",
        status: "ERROR",
        message: errorMessage,
      };
      window.parent.postMessage(JSON.stringify(messageObj), "*");
      return false;
    }
  }, [
    dispatch,
    carepakState.error.cardInvalid,
    carepakState.error.cardMissing,
    carepakState.error.cvvInvalid,
    carepakState.error.cvvEmpty,
    carepakState.decryptParams,
    carepakState.microformLoaded,
  ]);

  const toggleFields = useCallback(
    (addProfile: string) => {
      const disabled = addProfile === "true" ? false : true;

      if (disabled) {
        setCreditCardNumberBorderClass(`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.disable_datepicket}`);
        setSecurityCodeBorderClass(`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.disable_datepicket}`);
        setDatePickerBorderClass(`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.disable_datepicket}`);
      } else {
        setCreditCardNumberBorderClass(`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.enable_datepicket}`);
        setSecurityCodeBorderClass(`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.enable_datepicket}`);
        setDatePickerBorderClass(`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.enable_datepicket}`);
      }
      dispatch(setFormDisabled({ formDisabled: disabled }));
    },
    [dispatch],
  );

  const getLastFourCcAccountNum = (micoFormtoken: string) => {
    const tokenArray = micoFormtoken.split(".");
    let bufferObj = Buffer.from(tokenArray[1], "base64");

    //Encode the Buffer as a utf8 string
    let decodedString = bufferObj.toString("utf8");
    let jsonObject = JSON.parse(decodedString);
    let jti = jsonObject.jti;
    let lastFourDigits = jsonObject.content.paymentInformation.card.number.maskedValue.replaceAll("X", "");
    return [jti, lastFourDigits];
  };

  const invokeProfileAdd = useCallback(
    async (micoFormtoken: string) => {
      if (componentObjRef.current.submitPage) {
        componentObjRef.current.processingForm = true;
        let expYearMonth = datePickerRef.current?.input.value.toLocaleString();
        expYearMonth = "20" + expYearMonth.substring(3) + expYearMonth.substring(0, 2);

        const [jti, lastFourDigits] = getLastFourCcAccountNum(micoFormtoken);

        let address1 = carepakState.decryptParams["address1"];
        let address2 = carepakState.decryptParams["address2"];
        let city = carepakState.decryptParams["city"];
        let state = carepakState.decryptParams["state"];
        let zip = carepakState.decryptParams["zip"];
        let countryCode = carepakState.decryptParams["countryCode"];
        let proxyUrl = carepakState.decryptParams["tcepps.proxyUrl"];
        let amount = carepakState.decryptParams["amount"];
        if (carepakState.amount) {
          amount = carepakState.amount;
        }
        if (carepakState.avsAddress1) {
          address1 = carepakState.avsAddress1;
          address2 = carepakState.avsAddress2;
          city = carepakState.avsCity;
          state = carepakState.avsState;
          zip = carepakState.avsZip;
          countryCode = carepakState.avsCountryCode;
        }
        let email = carepakState.decryptParams["email"];
        if (!(email && email.length > 0)) {
          // email = DEFUSEREMAIL;
          email = carepakState.decryptParams["customerEmail"];
        }
        if (email && email.length > 0) {
          email = email.trim();
        } else {
          email = "null@cybersource.com";
        }
        if (!(countryCode && countryCode.length > 0)) {
          countryCode = "US";
        }
        if (!address1) {
          address1 = address2;
          address2 = "";
        }

        let orbitalConnectionUsername = getDecryptParams("orbitalConnectionUsername", carepakState.decryptParams);
        let orbitalConnectionPassword = getDecryptParams("orbitalConnectionPassword", carepakState.decryptParams);
        let switchSoloIssueNum = getDecryptParams("switchSoloIssueNum", carepakState.decryptParams);
        let switchSoloCardStartDate = getDecryptParams("switchSoloCardStartDate", carepakState.decryptParams);
        let authenticationECIInd = getDecryptParams("authenticationECIInd", carepakState.decryptParams);

        let address = address1;
        if (address2) {
          address = address + " " + address2;
        }
        if (address) {
          if (address.toLowerCase().indexOf("testdonothonorfailure") >= 0) {
            amount = "40100";
          }
          if (address.toLowerCase().indexOf("testaddressfailure") >= 0) {
            amount = "283600";
          }
          if (address.toLowerCase().indexOf("testcvvfailure") >= 0) {
            amount = "700500";
            // cvv = "111";
          }
          if (address.toLowerCase().indexOf("testdatefailure") >= 0) {
            amount = "252200";
          }
          if (address.toLowerCase().indexOf("testcardfailure") >= 0) {
            amount = "259500";
            // cvv = "111";
          }
          if (address.toLowerCase().indexOf("testapifailure") >= 0) {
            email = "abcd@";
          }
          if (address.toLowerCase().indexOf("testinsufficientfund") >= 0) {
            amount = "250900"; //2509 2521
          }
          if (address.toLowerCase().indexOf("testinsufficientfund2") >= 0) {
            amount = "252100"; //2509 2521
          }
        }
        // amount = "1003330000000";
        const carepackObj = {
          "pno.ccAccountNum": "TT=" + jti,
          "pno.ccExp": expYearMonth,
          "pno.ccCardVerifyNum": "",
          "pno.avsName": carepakState.avsName.toUpperCase().trim(),
          "pno.avsAddress1": address1 ? address1.toUpperCase().trim() : "",
          "pno.avsAddress2": address2 ? address2.toUpperCase().trim() : "",
          "pno.avsCity": city ? city.toUpperCase().trim() : "",
          "pno.avsState": state ? state.toUpperCase().trim() : "",
          "pno.avsZip": zip ? zip.toUpperCase().trim() : "",
          "pno.amount": !amount ? "100" : amount,
          "pno.orderID": carepakState.orderNumber,
          "tcepps.cardBrand": componentObjRef.current.glblCreditCardType,
          "tcepps.lastFourDigits": lastFourDigits,
          "pno.avsCountryCode": countryCode ? countryCode.toUpperCase().trim() : "US",
          "pno.customerEmail": email,
          "pno.orbitalConnectionUsername": orbitalConnectionUsername ? orbitalConnectionUsername : "",
          "pno.orbitalConnectionPassword": orbitalConnectionPassword ? orbitalConnectionPassword : "",
          "pno.switchSoloIssueNum": switchSoloIssueNum ? switchSoloIssueNum : "",
          "pno.switchSoloCardStartDate": switchSoloCardStartDate ? switchSoloCardStartDate : "",
          "pno.authenticationECIInd": authenticationECIInd ? authenticationECIInd : "",
          "tcepps.proxyUrl": proxyUrl,
          "tcepps.encryptedRequest": tceppsState.encryptedRequest,
          "tcepps.encryptedRequestKey": tceppsState.encryptedRequestKey,
          "tcepps.serviceOperation": "newOrder",
          "tcepps.app": tceppsState.app.toUpperCase().trim(),
          "tcepps.token": tceppsState.token,
          "tcepps.sign": tceppsState.sign,
          "pno.captureContext": paymentInfo.context,
          "pno.microformToken": paymentInfo.token,
          "tcepps.consumeOnSuccess": "Y",
        };
        toggleFields("false");
        CpgmuiService.submitCusac360b2bcarepakRest(carepackObj).then((resp: any) => {
          // console.log(resp.data);
          window.parent.postMessage({ type: "transactionResponse", payload: resp.data }, "*");
        });
      }
    },
    [
      toggleFields,
      tceppsState.app,
      tceppsState.token,
      tceppsState.sign,
      carepakState.decryptParams,
      tceppsState.encryptedRequest,
      tceppsState.encryptedRequestKey,
      carepakState.amount,
      carepakState.avsAddress1,
      carepakState.avsAddress2,
      carepakState.avsCity,
      carepakState.avsCountryCode,
      carepakState.avsName,
      carepakState.avsState,
      carepakState.avsZip,
      carepakState.orderNumber,
      paymentInfo.context,
      paymentInfo.token,
    ],
  );

  const createCybersourceToken = useCallback(async () => {
    if (isCybersourceTimedout(toDay)) {
      componentObjRef.current.isBackgroundRed = true;
      dispatch(setValidationMessage({ validationMessage: PROCESSING }));
      const { token, jti, lastFourDigits } = getTimedoutDummyToken();
      dispatch(tokenCreatedAction({ token, jti, lastFourDigits }));
    } else {
      componentObjRef.current.cardMessage = "";
      componentObjRef.current.cvvMessage = "";

      let expMonth = datePickerRef.current?.input.value.toLocaleString().substring(0, 2);
      let expYear = "20" + datePickerRef.current?.input.value.toLocaleString().substring(3);

      const options = {
        expirationMonth: expMonth,
        expirationYear: expYear,
      };

      // async function createMicroformToken(options: any) {
      await paymentInfo.microform.createToken(options, (err: Error, token: any) => {
        if (err) {
          console.log(err);
          dispatch(setValidationMessage({ validationMessage: err.name + "  " + err.message }));
          componentObjRef.current.otherErrMsg = "";
          componentObjRef.current.cardMessage = "";
          componentObjRef.current.cvvMessage = "";
          let foundCardMessage = true;
          // handle error
          // @ts-ignore
          switch (err.reason) {
            case "CREATE_TOKEN_NO_FIELDS_LOADED":
              componentObjRef.current.otherErrMsg = "Token creation error, no fields have been loaded." + err.message;
              break;
            case "CREATE_TOKEN_TIMEOUT":
              componentObjRef.current.otherErrMsg = "createToken call was unable to proceed." + err.message;
              break;
            case "CREATE_TOKEN_XHR_ERROR":
              componentObjRef.current.otherErrMsg = "Network error when attempting to create a token." + err.message;
              break;
            case "CREATE_TOKEN_NO_FIELDS":
              componentObjRef.current.otherErrMsg = "Data fields are unavailable for collection." + err.message;
              break;
            case "CREATE_TOKEN_VALIDATION_PARAMS":
              componentObjRef.current.otherErrMsg = "Issue with parameters supplied to createToken." + err.message;
              break;
            case "CREATE_TOKEN_VALIDATION_FIELDS":
              // @ts-ignore
              if (err.details && err.details.length > 0) {
                // @ts-ignore
                if (err.details.length > 1) {
                  componentObjRef.current.cardMessage = INVALIDCARDMESSAGE;
                  componentObjRef.current.cvvMessage = INVALIDCVVMESSAGE;
                  // @ts-ignore
                } else if (err.details[0].location === "number") {
                  componentObjRef.current.cardMessage = INVALIDCARDMESSAGE;
                  // @ts-ignore
                } else if (err.details[0].location === "securityCode") {
                  componentObjRef.current.cvvMessage = INVALIDCVVMESSAGE;
                  foundCardMessage = false;
                } else {
                  componentObjRef.current.otherErrMsg = err.message;
                }
              } else {
                componentObjRef.current.otherErrMsg = err.message;
              }
              break;
            case "CREATE_TOKEN_VALIDATION_SERVERSIDE":
              componentObjRef.current.otherErrMsg = "Server-side validation rejects the createToken request." + err.message;
              break;
            case "CREATE_TOKEN_UNABLE_TO_START":
              componentObjRef.current.otherErrMsg = "Loaded field was able to handle the createToken request." + err.message;
              break;
            default:
              componentObjRef.current.otherErrMsg = "Unknown error:" + err.message;
              break;
          }
          if (!foundCardMessage) componentObjRef.current.cardMessage = "";
          // checkCreditCard();
        } else {
          componentObjRef.current.isBackgroundRed = true;
          dispatch(setValidationMessage({ validationMessage: PROCESSING }));
          const { jti, lastFourDigits } = parseToken(token);
          dispatch(tokenCreatedAction({ token, jti, lastFourDigits }));
        }
      });
    }
  }, [paymentInfo.microform, dispatch]);

  // useEffect when input parameters are decrypted.
  useEffect(() => {
    if (carepakState.decryptParams && Object.keys(carepakState.decryptParams).length > 0 && carepakState.microformLoaded) {
      dispatch(setValidationMessage({ validationMessage: "" }));
      componentObjRef.current.isBackgroundRed = false;
    }
  }, [dispatch, carepakState.decryptParams, carepakState.microformLoaded]);

  // useEffect when new token is generated submit form
  useEffect(() => {
    if (!componentObjRef.current.processingForm && paymentInfo.token && carepakState.processForm) {
      if (checkCreditCard()) {
        componentObjRef.current.isBackgroundRed = true;
        dispatch(setValidationMessage({ validationMessage: PROCESSING }));
        const messageObj = {
          eventSource: "cpgmui",
          eventType: "Form Validation",
          status: "SUCCESS",
          message: PROCESSING,
        };
        dispatch(
          setCybrError({
            cvvCybrErrorMessage: "",
            cvvCybrError: false,
            cardCybrErrorMessage: "",
            cardCybrError: false,
            dateCybrErrorMessage: "",
            dateCybrError: false,
            nameCybrErrorMessage: "",
            nameCybrError: false,
          }),
        );
        window.parent.postMessage(JSON.stringify(messageObj), "*");
        invokeProfileAdd(paymentInfo.token);
      }
    }
  }, [dispatch, paymentInfo.token, checkCreditCard, invokeProfileAdd, carepakState.processForm]);

  const windowMessageHandler = useCallback(
    (event: MessageEvent) => {
      if (!carepakState.microformLoaded && event.data !== undefined && event.data === "processTransaction") {
        let errorMessage = FORMINITIZING;
        dispatch(setDatePickerOpen({ isDatePickerOpen: false }));
        dispatch(setValidationMessage({ validationMessage: FORMINITIZING }));
        componentObjRef.current.isBackgroundRed = true;
        const messageObj = {
          eventSource: "cpgmui",
          eventType: "Form Initialization Error",
          status: "ERROR",
          message: errorMessage,
        };
        window.parent.postMessage(JSON.stringify(messageObj), "*");
      } else if (carepakState.microformLoaded && event.data !== undefined && event.data === "processTransaction") {
        dispatch(setDatePickerOpen({ isDatePickerOpen: false }));
        // check the origin of the data!
        if (
          event.origin.startsWith("https://") &&
          (event.origin.indexOf(".usa.canon.com") > 0 ||
            event.origin.indexOf(".cusa.canon.com") > 0 ||
            event.origin.indexOf(".americas.canon.com") > 0 ||
            event.origin.indexOf("https://canonamericas") >= 0)
        ) {
          componentObjRef.current.submitPage = true;
          if (checkCreditCard()) {
            dispatch(setProcessForm({ processForm: true }));
            createCybersourceToken();
          }
        } else if (event.origin.startsWith("http://") && event.origin.indexOf("localhost") > 0) {
          componentObjRef.current.submitPage = true;
          if (checkCreditCard()) {
            dispatch(setProcessForm({ processForm: true }));
            createCybersourceToken();
          }
        } else {
          return;
        }
      } else if (
        // carepakState.microformLoaded &&
        event.data &&
        event.data.type &&
        event.data.type === "updateChargeAmount" &&
        event.data.payload
      ) {
        LogService.logMessage(carepakState.logErrorReference, LOGINFOLEVEL, "updateChargeAmount" + event.data.payload);
        let updateAmount = false;
        if (
          event.origin.startsWith("https://") &&
          (event.origin.indexOf(".usa.canon.com") > 0 ||
            event.origin.indexOf(".cusa.canon.com") > 0 ||
            event.origin.indexOf(".americas.canon.com") > 0 ||
            event.origin.indexOf("https://canonamericas") >= 0)
        ) {
          updateAmount = true;
        } else if (event.origin.startsWith("http://") && event.origin.indexOf("localhost") > 0) {
          updateAmount = true;
        }
        if (updateAmount) {
          dispatch(setAmount({ amount: event.data.payload }));
          const messageObj = {
            eventSource: "cpgmui",
            eventType: "Acknowledgement",
            status: "INFO",
            message: "updateChargeAmount processed",
          };
          window.parent.postMessage(JSON.stringify(messageObj), "*");
        }
      } else if (
        // carepakState.microformLoaded &&
        event.data &&
        event.data.type &&
        event.data.type === "changeBillingAddress" &&
        event.data.payload
      ) {
        LogService.logMessage(carepakState.logErrorReference, LOGINFOLEVEL, "changeBillingAddress" + getStringify(event.data.payload));
        let updateBillingAddress = false;
        if (
          event.origin.startsWith("https://") &&
          (event.origin.indexOf(".usa.canon.com") > 0 ||
            event.origin.indexOf(".cusa.canon.com") > 0 ||
            event.origin.indexOf(".americas.canon.com") > 0 ||
            event.origin.indexOf("https://canonamericas") >= 0)
        ) {
          updateBillingAddress = true;
        } else if (event.origin.startsWith("http://") && event.origin.indexOf("localhost") > 0) {
          updateBillingAddress = true;
        }
        if (updateBillingAddress) {
          dispatch(
            setBillingAddress({
              avsAddress1: event.data.payload.address1 ? event.data.payload.address1 : "",
              avsAddress2: event.data.payload.address2 ? event.data.payload.address2 : "",
              avsCity: event.data.payload.city ? event.data.payload.city : "",
              avsState: event.data.payload.st ? event.data.payload.st : "",
              avsZip: event.data.payload.zip ? event.data.payload.zip : "",
              avsCountryCode: event.data.payload.countryCode ? event.data.payload.countryCode : "",
              orderNumber: event.data.payload.orderNumber ? event.data.payload.orderNumber : "",
            }),
          );
          let logErrorReference = "CUSAC360B2BCAREPAK Order# " + event.data.payload.orderNumber;
          dispatch(setLogErrorReference({ logErrorReference: logErrorReference }));
          const messageObj = {
            eventSource: "cpgmui",
            eventType: "Acknowledgement",
            status: "INFO",
            message: "changeBillingAddress processed",
          };
          window.parent.postMessage(JSON.stringify(messageObj), "*");
          LogService.logMessage(logErrorReference, LOGINFOLEVEL, "changeBillingAddress completed" + getStringify(event.data.payload));
        }
      } else if (
        // carepakState.microformLoaded &&
        event.data &&
        event.data.type &&
        event.data.type === "cybrErrorMessage" &&
        event.data.payload
      ) {
        LogService.logMessage(carepakState.logErrorReference, LOGINFOLEVEL, "cybrErrorMessage" + event.data.payload);
        let updateCybrError = false;
        if (
          event.origin.startsWith("https://") &&
          (event.origin.indexOf(".usa.canon.com") > 0 ||
            event.origin.indexOf(".cusa.canon.com") > 0 ||
            event.origin.indexOf(".americas.canon.com") > 0 ||
            event.origin.indexOf("https://canonamericas") >= 0)
        ) {
          updateCybrError = true;
        } else if (event.origin.startsWith("http://") && event.origin.indexOf("localhost") > 0) {
          updateCybrError = true;
        }
        if (updateCybrError) {
          toggleFields("true");
          dispatch(setProcessForm({ processForm: false }));
          dispatch(tokenCreatedAction({ token: null, jti: null, lastFourDigits: null }));
          componentObjRef.current.processingForm = false;
          dispatch(
            setCybrError({
              cvvCybrErrorMessage:
                event.data.payload.cvvCybrErrorMessage && event.data.payload.cvvCybrErrorMessage !== ""
                  ? event.data.payload.cvvCybrErrorMessage
                  : "",
              cvvCybrError: event.data.payload.cvvCybrErrorMessage && event.data.payload.cvvCybrErrorMessage !== "" ? true : false,
              cardCybrErrorMessage:
                event.data.payload.cardCybrErrorMessage && event.data.payload.cardCybrErrorMessage !== ""
                  ? event.data.payload.cardCybrErrorMessage
                  : "",
              cardCybrError: event.data.payload.cardCybrErrorMessage && event.data.payload.cardCybrErrorMessage !== "" ? true : false,
              dateCybrErrorMessage:
                event.data.payload.dateCybrErrorMessage && event.data.payload.dateCybrErrorMessage !== ""
                  ? event.data.payload.dateCybrErrorMessage
                  : "",
              dateCybrError: event.data.payload.dateCybrErrorMessage && event.data.payload.dateCybrErrorMessage !== "" ? true : false,
              nameCybrErrorMessage:
                event.data.payload.nameCybrErrorMessage && event.data.payload.nameCybrErrorMessage !== ""
                  ? event.data.payload.nameCybrErrorMessage
                  : "",
              nameCybrError: event.data.payload.nameCybrErrorMessage && event.data.payload.nameCybrErrorMessage !== "" ? true : false,
            }),
          );
          if (event.data.payload.cvvCybrErrorMessage && event.data.payload.cvvCybrErrorMessage !== "" && cvvMicroSecurityCode) {
            cvvMicroSecurityCode.focus();
          }
          if (event.data.payload.cardCybrErrorMessage && event.data.payload.cardCybrErrorMessage !== "" && creditCardMicroNumber) {
            creditCardMicroNumber.focus();
          }
          if (event.data.payload.dateCybrErrorMessage && event.data.payload.dateCybrErrorMessage !== "" && datePickerRef.current) {
            datePickerRef.current?.input.focus();
          }
          if (event.data.payload.nameCybrErrorMessage && event.data.payload.nameCybrErrorMessage !== "" && customerNameRef.current) {
            customerNameRef.current?.focus();
          }
          dispatch(setValidationMessage({ validationMessage: "" }));
        }
        const messageObj = {
          eventSource: "cpgmui",
          eventType: "Acknowledgement",
          status: "INFO",
          message: "cybrErrorMessage processed",
        };
        window.parent.postMessage(JSON.stringify(messageObj), "*");
      } else if (
        event.data &&
        (event.data as any).data &&
        ((event.data as any).data as any).focusShift &&
        (event.data as any).event === "blur" &&
        event.currentTarget &&
        (event.currentTarget as any).name &&
        (event.currentTarget as any).name === "creditCardFormIFrame"
      ) {
        if (((event.data as any).data as any).focusShift === "next") {
          if (componentObjRef.current.microFromFocusField === "creditCardNumber") {
            componentObjRef.current.microFromFocusField = "";
            if (datePickerRef && datePickerRef.current && datePickerRef.current?.input) {
              datePickerRef.current?.input.focus();
            }
          } else if (componentObjRef.current.microFromFocusField === "securityCode") {
            componentObjRef.current.microFromFocusField = "";
            customerNameRef.current?.focus();
          }
        } else if (((event.data as any).data as any).focusShift === "previous") {
          if (componentObjRef.current.microFromFocusField === "creditCardNumber") {
            componentObjRef.current.microFromFocusField = "";
            customerNameRef.current?.focus();
          } else if (componentObjRef.current.microFromFocusField === "securityCode") {
            componentObjRef.current.microFromFocusField = "";
            if (datePickerRef && datePickerRef.current && datePickerRef.current?.input) {
              datePickerRef.current?.input.focus();
            }
          }
        }
      } else if (componentObjRef.current && event.data && typeof event.data === "string") {
        let fnd: boolean;
        try {
          fnd = (event.data as string).indexOf("/*cybs-telgram*/") >= 0;
        } catch (error) {
          fnd = false;
        }
        if (fnd) {
          const jsonObject = JSON.parse(event.data.replace("/*cybs-telgram*/", ""));
          if (
            jsonObject.data &&
            jsonObject.data.tabDirection &&
            jsonObject.data.tabDirection.focusShift &&
            jsonObject.event &&
            jsonObject.event === "event_blur" &&
            event.currentTarget &&
            (event.currentTarget as any).name &&
            ((event.currentTarget as any).name === "Mainframe" || (event.currentTarget as any).name === "creditCardFormIFrame")
          ) {
            if (jsonObject.data.tabDirection.focusShift === "next") {
              if (componentObjRef.current.microFromFocusField === "creditCardNumber") {
                componentObjRef.current.microFromFocusField = "";
                if (datePickerRef && datePickerRef.current && datePickerRef.current?.input) {
                  datePickerRef.current?.input.focus();
                }
              } else if (componentObjRef.current.microFromFocusField === "securityCode") {
                componentObjRef.current.microFromFocusField = "";
                customerNameRef.current?.focus();
              }
            } else if (jsonObject.data.tabDirection.focusShift === "previous") {
              if (componentObjRef.current.microFromFocusField === "creditCardNumber") {
                componentObjRef.current.microFromFocusField = "";
                customerNameRef.current?.focus();
              } else if (componentObjRef.current.microFromFocusField === "securityCode") {
                componentObjRef.current.microFromFocusField = "";
                if (datePickerRef && datePickerRef.current && datePickerRef.current?.input) {
                  datePickerRef.current?.input.focus();
                }
              }
            }
          }
        }
      }
    },
    [dispatch, createCybersourceToken, checkCreditCard, carepakState.microformLoaded, carepakState.logErrorReference, toggleFields],
  );

  // useEffect for windows message
  useEffect(() => {
    setAppName("C360CAREPAK");
    if (paymentInfo.isSuccessful) {
      window.addEventListener("message", windowMessageHandler, false);
    }

    return () => {
      window.removeEventListener("message", windowMessageHandler);
    };
  }, [windowMessageHandler, paymentInfo.isSuccessful]);

  // decrypt the input parameters
  const decryptInputParameterAsync = useCallback(
    async (app: string, encryptedRequestKey: string, encryptedRequest: string) => {
      let decryptParamsResponse: any;
      let logErrorReference = "CUSAC360B2BCAREPAK ";

      try {
        const response = await PaymentService.getDecryptRequest(app, encryptedRequestKey, encryptedRequest);
        decryptParamsResponse = response.data;
        toggleFields("true");
      } catch (err: any) {
        console.log(err);
        dispatch(setValidationMessage({ validationMessage: err.message }));
        if (axios.isAxiosError(err)) {
          // Access to config, request, and response
          let errorMessage = INVALIDAXIOSMESSAGE + "call to getDecryptRequest failed. " + err.message + ". Please check console..";
          dispatch(setValidationMessage({ validationMessage: errorMessage }));
          const messageObj = {
            eventSource: "cpgmui",
            eventType: "Form Initialization Error",
            status: "ERROR",
            message: errorMessage,
          };
          window.parent.postMessage(JSON.stringify(messageObj), "*");
        } else {
          // Just a stock error
          let errorMessage = "Error in getDecryptRequest. " + err.message + ". Please check console..";
          dispatch(setValidationMessage({ validationMessage: errorMessage }));
          const messageObj = {
            eventSource: "cpgmui",
            eventType: "Form Initialization Error",
            status: "ERROR",
            message: errorMessage,
          };
          window.parent.postMessage(JSON.stringify(messageObj), "*");
        }
        LogService.logMessage(logErrorReference, LOGERRORLEVEL, "PaymentService.getDecryptRequest call failed. " + err.message);
      }

      if (decryptParamsResponse && Object.keys(decryptParamsResponse).length > 0) {
        // check for proxy
        let iFrameUrl = document.referrer;
        if (iFrameUrl === undefined || iFrameUrl.trim().length === 0) {
          dispatch(setProxyUrl({ proxyUrl: decryptParamsResponse["tcepps.proxyUrl"] }));
        }
        dispatch(setDecryptParams({ decryptParams: decryptParamsResponse }));

        let fname = decryptParamsResponse["firstName"];
        let mname = decryptParamsResponse["middleName"];
        let lname = decryptParamsResponse["lastName"];
        fname = (fname ? fname : "") + (mname && mname.length > 0 ? " " + mname : "");
        fname = (fname ? fname : "") + (lname && lname.length > 0 ? " " + lname : "");
        if (fname && fname.trim().length > 0) {
          dispatch(
            setAvsName({
              avsName: fname.toUpperCase().trim(),
              avsNameEmpty: false,
            }),
          );
        }

        let inputExpirationDate = decryptParamsResponse["expirationDate"];
        if (inputExpirationDate && inputExpirationDate.length === 7) {
          dispatch(
            setExpYearMonth({
              ccExpYearMonth: convertMMYYYYToDate(inputExpirationDate.substring(0, 2) + "/" + inputExpirationDate.substring(3)),
            }),
          );
          // console.log(
          //   "9 setExpYearMonthValid ccExpExpired: " +
          //     (convertMMYYYYToDate(inputExpirationDate.substring(0, 2) + "/" + inputExpirationDate.substring(3)) < toDay) +
          //     "  ccExpInvalid: false  ccExpInvalid: false"
          // );
          dispatch(
            setExpYearMonthValid({
              ccExpExpired: isOlderDate(convertMMYYYYToDate(inputExpirationDate.substring(0, 2) + "/" + inputExpirationDate.substring(3))),
              ccExpInvalid: false,
              ccExpMissing: false,
            }),
          );
        }

        dispatch(setLogErrorReference({ logErrorReference: "CUSAC360B2BCAREPAK Order# " + decryptParamsResponse["orderNumber"] }));
        const messageObj = {
          eventSource: "cpgmui",
          eventType: "Form Initialization",
          status: "loaded",
          message: "loaded",
        };
        window.parent.postMessage(JSON.stringify(messageObj), "*");
      } else {
        let errorMessage = "Customer details not available. Please close and retry.";
        dispatch(setValidationMessage({ validationMessage: errorMessage }));
        const messageObj = {
          eventSource: "cpgmui",
          eventType: "Form Initialization",
          status: "ERROR",
          message: errorMessage,
        };
        window.parent.postMessage(JSON.stringify(messageObj), "*");
        LogService.logMessage(logErrorReference, LOGERRORLEVEL, "Customer details not available. Please close and retry.");
      }
    },
    [dispatch, toggleFields],
  );

  // useEffect if screen/page input parameters change. Dispatch state change
  useEffect(() => {
    dispatch(resetStateAndError());
    const appKey0 = Buffer.from(appKey ? appKey : "", "base64");
    const appKey1 = appKey0.toString("utf8");
    const mydata = JSON.parse(appKey1);
    toggleFields("false");

    let iFrameUrl = document.referrer;
    if (iFrameUrl && iFrameUrl.trim().length > 0) {
      dispatch(setProxyUrl({ proxyUrl: iFrameUrl }));
    }

    let requestParameter = {
      app: "",
      token: "",
      sign: "",
      serviceOperation: "",
      encryptedRequest: "",
      encryptedRequestKey: "",
      enableNewCrCardFlag: "",
      addProfile: "",
      cpgmuiApiUrl: "",
      cpgmuiEnv: "",
    };

    const getPortNumber = () => {
      const windowsUrl = window.location.href;
      const searchParams = windowsUrl.indexOf("//") + 2;
      const firstSlashIndex = windowsUrl.indexOf("/", searchParams);
      const colonIndex = windowsUrl.indexOf(":", searchParams);
      if (firstSlashIndex > 0 && colonIndex > 0) {
        return windowsUrl.substring(colonIndex + 1, firstSlashIndex);
      } else {
        return "";
      }
    };

    //find port if it exits
    const urlPortNumber = getPortNumber();

    Object.keys(mydata).forEach((key) => {
      switch (key) {
        case "tcepps.app":
          requestParameter.app = mydata[key];
          break;
        case "tcepps.token":
          requestParameter.token = mydata[key];
          break;
        case "tcepps.sign":
          requestParameter.sign = mydata[key];
          break;
        case "tcepps.serviceOperation":
          requestParameter.serviceOperation = mydata[key];
          break;
        case "tcepps.encryptedRequest":
          requestParameter.encryptedRequest = mydata[key];
          break;
        case "tcepps.encryptedRequestKey":
          requestParameter.encryptedRequestKey = mydata[key];
          break;
        case "tcepps.enableNewCrCardFlag":
          requestParameter.enableNewCrCardFlag = mydata[key];
          break;
        case "tcepps.addProfile":
          requestParameter.addProfile = mydata[key];
          break;
        case "cpgmuiApiUrl":
          requestParameter.cpgmuiApiUrl = mydata[key] + "/TCEPPS/jsp/tceppsHtmlFormInterface.jsp?tceppsApp=";
          if (urlPortNumber !== "") {
            let backendPortNumber = getPortNumber();
            if (backendPortNumber !== urlPortNumber) {
              requestParameter.cpgmuiApiUrl = requestParameter.cpgmuiApiUrl.replace(backendPortNumber, urlPortNumber);
            }
          }
          break;
        case "cpgmuiEnv":
          requestParameter.cpgmuiEnv = mydata[key];
          break;
      }
    });
    requestParameter.cpgmuiApiUrl += requestParameter.app;

    dispatch(
      tceppsActions.initializeTceppsAction({
        app: requestParameter.app,
        token: requestParameter.token,
        sign: requestParameter.sign,
        serviceOperation: requestParameter.serviceOperation,
        encryptedRequest: requestParameter.encryptedRequest,
        encryptedRequestKey: requestParameter.encryptedRequestKey,
        enableNewCrCardFlag: requestParameter.enableNewCrCardFlag,
        cpgmuiApiUrl: requestParameter.cpgmuiApiUrl,
        cpgmuiEnv: requestParameter.cpgmuiEnv,
      }),
    );

    try {
      getYearsFromToday(6, document.getElementById("expirationYear") as HTMLSelectElement, false);
    } catch (error) {}

    // setExpirationMonthYearDate(new Date());
    setCreditCardType("");

    dispatch(setValidationMessage({ validationMessage: "" }));
    componentObjRef.current.isBackgroundRed = false;

    decryptInputParameterAsync(
      requestParameter.app.toUpperCase().trim(),
      requestParameter.encryptedRequestKey,
      requestParameter.encryptedRequest,
    );
  }, [appKey, dispatch, decryptInputParameterAsync, toggleFields]);

  // useEffect when form get loaded. setup microform
  useEffect(() => {
    function selectGivenCardType(cardName: string, cardValid: boolean, cardEmpty: boolean) {
      let varCreditCardType = "";
      let detectedCard = false;
      if (cardName.length > 0) {
        switch (cardName) {
          case "VI":
          case "visa":
            varCreditCardType = "visa";
            detectedCard = true;
            break;
          case "MC":
          case "mastercard":
            varCreditCardType = "mastercard";
            detectedCard = true;
            break;
          case "AX":
          case "amex":
            varCreditCardType = "amex";
            detectedCard = true;
            break;
          case "DI":
          case "discover":
            varCreditCardType = "discover";
            detectedCard = true;
            break;
        }
      }

      if (detectedCard) {
        setCreditCardType(varCreditCardType);
        dispatch(setCardType({ cardBrand: cardName, cardInvalid: !cardValid, cardMissing: cardEmpty }));
      } else {
        setCreditCardType("");
        dispatch(setCardType({ cardBrand: "", cardInvalid: !cardValid, cardMissing: cardEmpty }));
      }

      let errMessage = "Credit Card# needs to be entered.";
      if (!detectedCard) {
        errMessage = "Please enter a visa or a mastercard or amex or discover card#.";
      } else if (cardEmpty) {
        errMessage = "Credit Card# needs to be entered.";
      } else if (!cardValid) {
        errMessage = "Please enter a valid Credit card#.";
      } else if (cardValid) {
        errMessage = "";
      }

      componentObjRef.current.cardMessage = errMessage;
    }

    const loadCybersourceJS = (captureContext: any, clientLibrary: string, clientLibraryIntegrity: string, callback: (cc: any) => any) => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      // script.src = config.cybersource.microformJs;
      script.src = clientLibrary;
      script.integrity = clientLibraryIntegrity;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);
      script.onload = () => {
        callback(captureContext);
      };
    };

    const initializeMicroform = async (captureContext: any) => {
      // @ts-ignore
      const flex = await new window.Flex(captureContext);
      const microform = await flex.microform("card", { styles: flexStyles });
      creditCardMicroNumber = await microform.createField("number", { placeholder: "Enter Card Number" });
      cvvMicroSecurityCode = await microform.createField("securityCode", { placeholder: "Enter CVV" });
      await creditCardMicroNumber.load("#creditCardNumber");
      await cvvMicroSecurityCode.load("#securityCode");
      dispatch(microformInitializedAction(microform));

      if (creditCardMicroNumber) {
        //add listener
        creditCardMicroNumber.on("change", function (data: any) {
          if (data.card && data.card.length > 0) {
            selectGivenCardType(data.card[0].name, data.valid, data.empty);
          } else {
            selectGivenCardType("", data.valid, data.empty);
          }
        });
        creditCardMicroNumber.on("load", function () {
          // creditCardMicroNumber.focus();
          customerNameRef.current?.focus();
          dispatch(setMicroformLoaded({ microformLoaded: true }));
        });
        creditCardMicroNumber.on("focus", function () {
          componentObjRef.current.microFromFocusField = "creditCardNumber";
          dispatch(setDatePickerOpen({ isDatePickerOpen: false }));
          setCreditCardNumberBorderClass(`${classesC360b2bcarepak.Search__SearchInput_focus}`);
        });
        creditCardMicroNumber.on("blur", function () {
          setCreditCardNumberBorderClass("");
        });
      }
      if (cvvMicroSecurityCode) {
        cvvMicroSecurityCode.on("focus", function () {
          componentObjRef.current.microFromFocusField = "securityCode";
          dispatch(setDatePickerOpen({ isDatePickerOpen: false }));
          setSecurityCodeBorderClass(`${classesC360b2bcarepak.Search__SearchInput_focus}`);
        });
        cvvMicroSecurityCode.on("blur", function () {
          setSecurityCodeBorderClass("");
        });
        cvvMicroSecurityCode.on("change", function (data: any) {
          if (data.empty || !data.valid) {
            dispatch(setCvv({ cvvValid: false, cvvEmpty: data.empty }));
          } else if (data.valid) {
            dispatch(setCvv({ cvvValid: true, cvvEmpty: data.empty }));
          }
        });
      }
    };

    const getCaptureContext = async () => {
      await PaymentService.getCaptureContext(extractDomain(carepakState.proxyUrl))
        .then((resp) => {
          const captureContext = resp.data.captureContext;
          const { clientLibrary, clientLibraryIntegrity } = extractClientLibrary(resp.data.json);
          dispatch(contextLoadedAction(captureContext));
          // @ts-ignore
          if (!window.Flex) {
            loadCybersourceJS(captureContext, clientLibrary, clientLibraryIntegrity, initializeMicroform);
          } else {
            initializeMicroform(captureContext);
          }
          dispatch(setInitializationComplted({ initializationComplted: true }));
          return () => {
            dispatch(unmountAction);
            dispatch(setInitializationComplted({ initializationComplted: false }));
          };
        })
        .catch((err: Error | AxiosError) => {
          console.log(err);
          dispatch(setValidationMessage({ validationMessage: err.message }));
          if (axios.isAxiosError(err)) {
            let errorMessage = INVALIDAXIOSMESSAGE + "call to initialize microForm failed. " + err.message + ". Please check console.";
            dispatch(setValidationMessage({ validationMessage: errorMessage }));
            const messageObj = {
              eventSource: "cpgmui",
              eventType: "Form Initialization",
              status: "ERROR",
              message: errorMessage,
            };
            window.parent.postMessage(JSON.stringify(messageObj), "*");
          } else {
            let errorMessage = "Initialize microForm failed. " + err.message + ". Please check console.";
            dispatch(setValidationMessage({ validationMessage: errorMessage }));
            const messageObj = {
              eventSource: "cpgmui",
              eventType: "Form Initialization",
              status: "ERROR",
              message: errorMessage,
            };
            window.parent.postMessage(JSON.stringify(messageObj), "*");
          }
          componentObjRef.current.isBackgroundRed = true;
          LogService.logMessage(carepakState.logErrorReference, LOGERRORLEVEL, "Initialize microForm failed. " + err.message);
          dispatch(setInitializationComplted({ initializationComplted: true }));
        });
    };
    if (windowSize.width > 440) {
      setLargeScreen(true);
    } else {
      setLargeScreen(false);
    }
    if (!carepakState.initializationComplted && carepakState.proxyUrl && carepakState.proxyUrl.length > 0) {
      getCaptureContext();
    }
  }, [dispatch, carepakState.proxyUrl, windowSize.width, carepakState.logErrorReference, carepakState.initializationComplted]);

  const onChangeHandler = (identifier: string, event: ChangeEvent & { target: HTMLInputElement }) => {
    switch (identifier) {
      case "customerName":
        let value = event.target.value;
        if (value.trim().length > 0) {
          value = event.target.value.replace(/[^a-zA-ZÀ-ÿ\s\-'’]/gi, "");
        }
        dispatch(
          setAvsName({
            avsName: value.toUpperCase(),
            avsNameEmpty: value && value.trim().length > 0 ? false : true,
          }),
        );
        break;
    }
  };

  return (
    <>
      <form id="tcepps" name="tcepps" action={tceppsState.cpgmuiApiUrl} target="_self">
        <input id="app" name="app" type="hidden" value={tceppsState.app} />
        <input id="token" name="token" type="hidden" value={tceppsState.token} />
        <input id="sign" name="sign" type="hidden" value={tceppsState.sign} />
        <input id="serviceOperation" name="serviceOperation" type="hidden" value="" />
        <input id="encryptedRequest" name="encryptedRequest" type="hidden" value={tceppsState.encryptedRequest} />
        <input id="encryptedRequestKey" name="encryptedRequestKey" type="hidden" value={tceppsState.encryptedRequestKey} />
        <input id="lastFourCcAccountNum" name="lastFourCcAccountNum" type="hidden" value="" />
        <input id="proxyUrl" name="proxyUrl" type="hidden" value="" />
      </form>
      <form id="pno" name="pno">
        <input id="ccAccountNum" name="ccAccountNum" type="hidden" value="" />
        <input id="ccExp" name="ccExp" type="hidden" value="" />
        <input id="ccCardVerifyNum" name="ccCardVerifyNum" type="hidden" value="" />
        <input id="avsName" name="avsName" type="hidden" value="" />
        <input id="avsAddress1" name="avsAddress1" type="hidden" value="" />
        <input id="avsAddress2" name="avsAddress2" type="hidden" value="" />
        <input id="avsCity" name="avsCity" type="hidden" value="" />
        <input id="avsState" name="avsState" type="hidden" value="" />
        <input id="avsZip" name="avsZip" type="hidden" value="" />
        <input id="avsCountryCode" name="avsCountryCode" type="hidden" value="" />
        <input id="amount" name="amount" type="hidden" value="" />
        <input id="orderID" name="orderID" type="hidden" value="" />
        <input id="cardBrand" name="cardBrand" type="hidden" value="" />
        <input id="customerEmail" name="customerEmail" type="hidden" value="" />
        <input id="customerPhone" name="customerPhone" type="hidden" value="" />
      </form>
      <div className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.top_level}`}>
        <div className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.custom_overlay}`}>
          <div className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Popup__card}`}>
            <div className="">
              <form id="creditCard" className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Form__Form}`}>
                <div id="info-field" className="">
                  <div
                    className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Row__Row} ${classesC360b2bcarepak.Row__padding_sm_label}`}
                  >
                    <div
                      className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                    >
                      <label
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__field}`}
                        htmlFor="customerName"
                        style={{
                          color:
                            componentObjRef.current.submitPage && (carepakState.error.avsNameEmpty || carepakState.error.nameCybrError)
                              ? "#B51A1A"
                              : "black",
                        }}
                      >
                        <mark style={{ backgroundColor: "white", color: "red", fontWeight: "bold" }}>*</mark> Name on Card
                      </label>
                    </div>
                    {isLargeScreen && (
                      <div
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                      ></div>
                    )}
                  </div>

                  <div
                    className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Row__Row__Left} ${classesC360b2bcarepak.Row__padding_sm_label}`}
                  >
                    <div
                      className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                    >
                      <div
                        className={
                          componentObjRef.current.submitPage && (carepakState.error.avsNameEmpty || carepakState.error.nameCybrError)
                            ? `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__group} ${classesC360b2bcarepak.RedBorder}`
                            : `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__group}`
                        }
                      >
                        <input
                          id="customerName"
                          name="customerName"
                          type="text"
                          placeholder="Enter Name on Card"
                          size={25}
                          maxLength={customerNameMaxLength}
                          tabIndex={1}
                          value={carepakState.avsName}
                          disabled={carepakState.formDisabled}
                          ref={customerNameRef}
                          className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Input__Input} ${classesC360b2bcarepak.Sample__container__content} ${classesC360b2bcarepak.react_calendar} ${datePickerBorderClass}`}
                          onChange={(event) => onChangeHandler("customerName", event)}
                          onBlur={(event) => onBlurHandler("customerName", event)}
                          onKeyDown={(event) => onKeyDownHandler("customerName", event)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Row__Row}`}>
                    <div
                      className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                    >
                      <label
                        id="customerNameLabel"
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__field}`}
                        htmlFor="customerName"
                        style={{ color: "#B51A1A" }}
                      >
                        {componentObjRef.current.submitPage && carepakState.error.avsNameEmpty
                          ? FIELDISREQUIRED
                          : carepakState.error.nameCybrError
                            ? carepakState.nameCybrErrorMessage
                            : ""}
                      </label>
                    </div>
                    {isLargeScreen && (
                      <div
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                      ></div>
                    )}
                  </div>

                  <div style={margin20Style}>
                    <div className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__group}`}></div>
                  </div>

                  <div id="cnumdiv">
                    <div
                      className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Row__Row} ${classesC360b2bcarepak.Row__padding_sm_label}`}
                    >
                      <div
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                      >
                        <label
                          className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__field}`}
                          htmlFor="creditCardNumber"
                          style={{
                            color:
                              componentObjRef.current.submitPage &&
                              (carepakState.error.cardInvalid || carepakState.error.cardMissing || carepakState.error.cardCybrError)
                                ? "#B51A1A"
                                : "black",
                          }}
                        >
                          <mark style={{ backgroundColor: "white", color: "red", fontWeight: "bold" }}>*</mark> Card Number
                        </label>
                      </div>
                      <div
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v}`}
                      ></div>
                    </div>
                    <div className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Row__Row}`}>
                      <div
                        className={
                          isLargeScreen
                            ? `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`
                            : `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_7v} ${classesC360b2bcarepak.Col__padding_sm}`
                        }
                      >
                        <div>
                          <div
                            className={
                              componentObjRef.current.submitPage &&
                              (carepakState.error.cardInvalid || carepakState.error.cardMissing || carepakState.error.cardCybrError)
                                ? `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__group} ${classesC360b2bcarepak.RedBorder}`
                                : `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__group}`
                            }
                          >
                            <div
                              className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Input__Input} ${classesC360b2bcarepak.Search__SearchInput} ${creditCardNumberBorderClass}`}
                            >
                              <div
                                id="creditCardNumber"
                                style={creditCardStyle}
                                tabIndex={2}
                                aria-disabled={carepakState.formDisabled}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={
                          isLargeScreen
                            ? `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v}`
                            : `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_4v}`
                        }
                      >
                        <div
                          className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Row__Row} ${classesC360b2bcarepak.Row__padding_smb} ${classesC360b2bcarepak.Row__Row_Left}`}
                        >
                          <div className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.CardButton__Group_sm}`}>
                            <div className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.CardButton__inner_sm}`}>
                              <div
                                className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Link__Link} ${classesC360b2bcarepak.CardButton__CardButton_sm}`}
                              >
                                <input
                                  type="radio"
                                  value="visa"
                                  name="cardtype"
                                  id="visa"
                                  tabIndex={-1}
                                  disabled={true}
                                  checked={carepakState.cardBrand === "visa" || carepakState.cardBrand === "VI"}
                                  onClick={() => {
                                    return false;
                                  }}
                                />
                                <label htmlFor="visa" id="visalabel">
                                  <Tooltip
                                    anchorSelect="#visalabel"
                                    style={tooltipStyle}
                                    place="top-end"
                                    variant="info"
                                    content="VISA"
                                    opacity="0.4"
                                    delayShow={1500}
                                  />
                                </label>
                                {isLargeScreen && <img src={require("./img/vi.png")} alt="Visa" />}
                                {!isLargeScreen && <img src={require("./img/vi_sm.png")} alt="Visa" />}
                              </div>
                              <div
                                className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Link__Link} ${classesC360b2bcarepak.CardButton__CardButton_sm}`}
                              >
                                <input
                                  type="radio"
                                  value="mastercard"
                                  name="cardtype"
                                  tabIndex={-1}
                                  disabled={true}
                                  checked={carepakState.cardBrand === "mastercard" || carepakState.cardBrand === "MC"}
                                  id="mastercard"
                                  onClick={() => {
                                    return false;
                                  }}
                                />
                                <label htmlFor="mastercard" id="mastercardlabel">
                                  <Tooltip
                                    anchorSelect="#mastercardlabel"
                                    style={tooltipStyle}
                                    place="top-end"
                                    variant="info"
                                    content="MasterCard"
                                    opacity="0.4"
                                    delayShow={1500}
                                  />
                                </label>
                                {isLargeScreen && <img src={require("./img/mc.png")} alt="Mastercard" />}
                                {!isLargeScreen && <img src={require("./img/mc_sm.png")} alt="Mastercard" />}
                              </div>
                              <div
                                className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Link__Link} ${classesC360b2bcarepak.CardButton__CardButton_sm}`}
                              >
                                <input
                                  type="radio"
                                  value="amex"
                                  name="cardtype"
                                  id="amex"
                                  tabIndex={-1}
                                  disabled={true}
                                  checked={carepakState.cardBrand === "amex" || carepakState.cardBrand === "AX"}
                                  onClick={() => {
                                    return false;
                                  }}
                                />
                                <label htmlFor="amex" id="amexlabel">
                                  <Tooltip
                                    anchorSelect="#amexlabel"
                                    style={tooltipStyle}
                                    place="top-end"
                                    variant="info"
                                    content="AMEX"
                                    opacity="0.4"
                                    delayShow={1500}
                                  />
                                </label>
                                {isLargeScreen && <img src={require("./img/ae.png")} alt="American Express" />}
                                {!isLargeScreen && <img src={require("./img/ae_sm.png")} alt="American Express" />}
                              </div>
                              <div
                                className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Link__Link} ${classesC360b2bcarepak.CardButton__CardButton_sm}`}
                              >
                                <input
                                  type="radio"
                                  value="discover"
                                  name="cardtype"
                                  tabIndex={-1}
                                  disabled={true}
                                  id="discover"
                                  checked={carepakState.cardBrand === "discover" || carepakState.cardBrand === "DI"}
                                  onClick={() => {
                                    return false;
                                  }}
                                />
                                <label htmlFor="discover" id="discoverlabel">
                                  <Tooltip
                                    anchorSelect="#discoverlabel"
                                    style={tooltipStyle}
                                    place="top-end"
                                    variant="info"
                                    content="Discover"
                                    opacity="0.4"
                                    delayShow={1500}
                                  />
                                </label>
                                {isLargeScreen && <img src={require("./img/di.png")} alt="Discover" />}
                                {!isLargeScreen && <img src={require("./img/di_sm.png")} alt="Discover" />}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Row__Row} ${classesC360b2bcarepak.Row__padding_sm}`}
                    >
                      <div
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                      >
                        <label
                          className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__field}`}
                          htmlFor="creditCardNumber"
                          style={{ color: "#B51A1A" }}
                        >
                          {componentObjRef.current.submitPage && carepakState.error.cardMissing
                            ? FIELDISREQUIRED
                            : componentObjRef.current.submitPage && carepakState.error.cardInvalid
                              ? INVALIDCARDMESSAGE
                              : componentObjRef.current.submitPage && carepakState.error.cardCybrError
                                ? carepakState.cardCybrErrorMessage
                                : ""}
                        </label>
                      </div>
                      <div
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v}`}
                      ></div>
                    </div>

                    <div
                      className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Row__Row} ${classesC360b2bcarepak.Row__padding_sm_label}`}
                    >
                      <div
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                      >
                        <label
                          className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__field}`}
                          htmlFor="expirationMonthYear"
                          style={{
                            color:
                              componentObjRef.current.submitPage &&
                              (carepakState.error.ccExpExpired ||
                                carepakState.error.ccExpInvalid ||
                                carepakState.error.ccExpMissing ||
                                carepakState.error.dateCybrError)
                                ? "#B51A1A"
                                : "black",
                          }}
                        >
                          <mark style={{ backgroundColor: "white", color: "red", fontWeight: "bold" }}>*</mark> Expiration Date
                        </label>
                      </div>
                      {isLargeScreen && (
                        <div
                          className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm_10Left}`}
                        >
                          <label
                            className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__field}`}
                            htmlFor="securityCode"
                            style={{
                              color:
                                componentObjRef.current.submitPage &&
                                (carepakState.error.cvvEmpty || carepakState.error.cvvInvalid || carepakState.error.cvvCybrError)
                                  ? "#B51A1A"
                                  : "black",
                            }}
                          >
                            <mark style={{ backgroundColor: "white", color: "red", fontWeight: "bold" }}>*</mark> CVV
                          </label>
                        </div>
                      )}
                    </div>
                    <div
                      className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Row__Row} ${classesC360b2bcarepak.Row__padding_sm_label}`}
                    >
                      <div
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                      >
                        <div className="" id="b">
                          <div
                            className={
                              componentObjRef.current.submitPage &&
                              (carepakState.error.ccExpMissing ||
                                carepakState.error.ccExpInvalid ||
                                carepakState.error.ccExpExpired ||
                                carepakState.error.dateCybrError)
                                ? `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__group} ${classesC360b2bcarepak.RedBorder}`
                                : `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__group}`
                            }
                          >
                            <DatePicker
                              key="expirationMonthYear"
                              id="expirationMonthYear"
                              name="expirationMonthYear"
                              tabIndex={3}
                              placeholderText="MM/YY"
                              showIcon
                              icon={
                                <span
                                  role="img"
                                  aria-label="calendar"
                                  onClick={() => dispatch(setDatePickerOpen({ isDatePickerOpen: !carepakState.isDatePickerOpen }))}
                                >
                                  📅
                                </span>
                              }
                              disabled={carepakState.formDisabled}
                              dateFormat="MM/yy"
                              ref={datePickerRef}
                              toggleCalendarOnIconClick
                              selected={carepakState.ccExpYearMonth}
                              open={carepakState.isDatePickerOpen}
                              onFocus={() => dispatch(setDatePickerOpen({ isDatePickerOpen: true }))} // Show popover on focus
                              onSelect={handleDateSelect} //when day is clicked
                              onChange={handleDateChange} //only when value has changed
                              onChangeRaw={(e) => handleChangeRaw(e)}
                              onKeyDown={(event) => onKeyDownHandler("expirationMonthYear", event)}
                              onBlur={(event) => onBlurHandler("expirationMonthYear", event)}
                              showMonthYearPicker
                              shouldCloseOnSelect
                              minDate={new Date()}
                              maxDate={addYears(6)}
                              popperPlacement="bottom-end"
                              popperProps={{ strategy: "fixed" }}
                              className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Input__Input} ${classesC360b2bcarepak.Sample__container__content} ${classesC360b2bcarepak.react_calendar} ${datePickerBorderClass}`}
                            />
                          </div>
                        </div>
                      </div>

                      {!isLargeScreen && (
                        <>
                          <div
                            className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                          >
                            <label
                              className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__field}`}
                              htmlFor="expirationMonthYear"
                              style={{ color: "#B51A1A" }}
                            >
                              {componentObjRef.current.submitPage && (carepakState.error.ccExpMissing || carepakState.error.ccExpInvalid)
                                ? FIELDISREQUIRED
                                : componentObjRef.current.submitPage && carepakState.error.ccExpExpired
                                  ? INVALIDDATEMESSAGE
                                  : componentObjRef.current.submitPage && carepakState.error.dateCybrError
                                    ? carepakState.dateCybrErrorMessage
                                    : ""}
                            </label>
                          </div>
                          <div
                            className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm} ${classesC360b2bcarepak.Col__marginTop}`}
                          >
                            <label
                              className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__field}`}
                              htmlFor="securityCode"
                              style={{
                                color:
                                  componentObjRef.current.submitPage &&
                                  (carepakState.error.cvvEmpty || carepakState.error.cvvInvalid || carepakState.error.cvvCybrError)
                                    ? "#B51A1A"
                                    : "black",
                              }}
                            >
                              <mark style={{ backgroundColor: "white", color: "red", fontWeight: "bold" }}>*</mark> CVV
                            </label>
                          </div>
                        </>
                      )}

                      <div
                        className={
                          isLargeScreen
                            ? `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v}  ${classesC360b2bcarepak.Col__padding_sm} ${classesC360b2bcarepak.Col__padding_sm_10Left}`
                            : `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v}  ${classesC360b2bcarepak.Col__padding_sm}`
                        }
                      >
                        <div className="" id="a">
                          <div
                            className={
                              componentObjRef.current.submitPage &&
                              (carepakState.error.cvvEmpty || carepakState.error.cvvInvalid || carepakState.error.cvvCybrError)
                                ? `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__group} ${classesC360b2bcarepak.RedBorder}`
                                : `${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__group}`
                            }
                          >
                            <div className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Search__SearchContainer}`}>
                              <div
                                className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Input__Input} ${classesC360b2bcarepak.Search__SearchInput} ${securityCodeBorderClass}`}
                              >
                                <div id="securityCode" style={creditCardStyle} tabIndex={4} aria-disabled={carepakState.formDisabled}></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Row__Row} ${classesC360b2bcarepak.Row__padding_sm_label}`}
                    >
                      {isLargeScreen && (
                        <div
                          className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm}`}
                        >
                          <label
                            className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__field}`}
                            htmlFor="expirationMonthYear"
                            style={{ color: "#B51A1A" }}
                          >
                            {componentObjRef.current.submitPage && (carepakState.error.ccExpMissing || carepakState.error.ccExpInvalid)
                              ? FIELDISREQUIRED
                              : componentObjRef.current.submitPage && carepakState.error.ccExpExpired
                                ? INVALIDDATEMESSAGE
                                : componentObjRef.current.submitPage && carepakState.error.dateCybrError
                                  ? carepakState.dateCybrErrorMessage
                                  : ""}
                          </label>
                        </div>
                      )}
                      <div
                        className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Col__Col} ${classesC360b2bcarepak.Col__sm_12} ${classesC360b2bcarepak.Col__md_6v} ${classesC360b2bcarepak.Col__padding_sm_10Left}`}
                      >
                        <label
                          className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.Label__field}`}
                          htmlFor="securityCode"
                          style={{ color: "#B51A1A" }}
                        >
                          {componentObjRef.current.submitPage && carepakState.error.cvvEmpty
                            ? FIELDISREQUIRED
                            : componentObjRef.current.submitPage && carepakState.error.cvvInvalid
                              ? INVALIDCVVMESSAGE
                              : componentObjRef.current.submitPage && carepakState.error.cvvCybrError
                                ? carepakState.cvvCybrErrorMessage
                                : ""}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div style={{ display: "flex", textAlign: "left", verticalAlign: "middle" }}>
                    <h1
                      className={`${classesC360b2bcarepak.c360b2bcarepak} ${classesC360b2bcarepak.h1}`}
                      id="validationMessage"
                      tabIndex={5}
                      style={{
                        color: "#B51A1A",
                        display: "inline-flex" /* keep the background color wrapped tight */,
                        backgroundColor:
                          componentObjRef.current.isBackgroundRed && carepakState.validationMessage.trim().length > 0 ? "#FFBABA" : "white",
                      }}
                    >
                      {carepakState.validationMessage.trim()}
                    </h1>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
